module.exports = "/_next/static/images/617bb8ea78941689173af079730ab62d-exame.png";